//react-components
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { withRouter } from "react-router";
import { connect } from "react-redux";

// Utils
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

//Constants
import { USER_ROLES } from "../Utils/Constants";

//Assets
import logo from "../Assets/images/src_resources_images_ic_logo_sanerret.svg";
import ProfileImage from "../Assets/images/ic_header_default_user.svg";

//Styles
import "./Header.scss";

//Strings
import { Strings } from "../Translations/i18n";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      profilePicUrl: null,
      avatar: null,
    }; // can be initialized by <Select value='someValue' />
  }

  componentDidMount() {
    this.setState({ showLoadingModal: true });
    this.props.getProfilePhoto(this.props.loggedInUserData.userName);
  }

  static getDerivedStateFromProps(nextProps, _prevState) {
    return {
      profilePicUrl: nextProps.loggedInUserData.profilePicData
        ? nextProps.loggedInUserData.profilePicData
        : nextProps.profilePicUrl,
    };
  }

  //handle change password
  clickChangePassword = () => {
    //Push route of change password
    this.props.history.push(APPLICATION_CONFIGURATIONS.path.changePassword);
  };
  //handle get profile
  handleProfile = () => {
    this.props.handleProfile();
  };

  /**
   * Redirect to the Login page
   */
  handleLogout = () => {
    this.props.handleLogout();
  };

  render() {
    return (
      <Row className="noPadding Header">
        <Col md={2}>
          <img src={logo} alt="" className="quisqueyaLogo" />
        </Col>
        {this.props.loggedInUserData.userName && (
          <Col md={4} className="profileDropdown">
            <Col md={12}>
              <DropdownButton id="dropdown-item-button" title="">
                {this.props.loggedInUserData.authority !==
                USER_ROLES.cashier ? (
                  <Dropdown.Item
                    className="form-control"
                    as="button"
                    eventKey="3"
                    onClick={this.handleProfile}
                  >
                    {Strings("profile")}
                  </Dropdown.Item>
                ) : (
                  <div />
                )}
                {this.props.loggedInUserData.authority !==
                USER_ROLES.cashier ? (
                  <Dropdown.Item
                    className="form-control"
                    as="button"
                    eventKey="1"
                    onClick={this.clickChangePassword}
                  >
                    {Strings("changePassword")}
                  </Dropdown.Item>
                ) : (
                  <div />
                )}
                <Dropdown.Item
                  as="button"
                  eventKey="2"
                  className="form-control"
                  onClick={this.handleLogout}
                >
                  {Strings("logout")}
                </Dropdown.Item>
              </DropdownButton>
              <span className="pull-right dropdownName noPadding">
                <div className="profileName textOverflow">
                  {this.props.loggedInUserData.firstName +
                    " " +
                    this.props.loggedInUserData.lastName}
                </div>
                <div className="profileSubName">
                  {Strings(this.props.loggedInUserData.authority)}
                </div>
              </span>
              <span className="pull-right profileImageSection">
                <img
                  src={
                    this.state.profilePicUrl === null
                      ? ProfileImage
                      : this.state.profilePicUrl
                  }
                  alt=""
                  className="profileImg"
                />
              </span>
            </Col>
          </Col>
        )}
        {/* Handle the click of Changepassword */}
      </Row>
    );
  }
}
export default withRouter(connect(null, null)(Header));
